import bank from './bank'
import businessOpportunity from './business-opportunity'
import commodity from './commodity'
import taskCompletionTime from './task-completion-time'
export default {
  partnerAccept: {
    method: 'get',
    url: '/partner/accept',
    headers: {
      tokenInvite: ''
    }
  },
  'get-list': {
    method: 'post',
    url: '/partner/list'
  },
  'get-detail': {
    method: 'get',
    url: '/partner/ID'
  },
  'partner-add': {
    method: 'post',
    url: '/partner'
  },
  'partner-edit': {
    method: 'put',
    url: '/partner/ID'
  },
  'partner-delete': {
    method: 'delete',
    url: '/partner'
  },
  archive: {
    method: 'delete',
    url: '/partner/archive'
  },
  restore: {
    method: 'put',
    url: '/partner/restore'
  },
  find: {
    method: 'get',
    url: '/partner/find'
  },
  findContact: {
    method: 'get',
    url: '/partner/contact/COOPERATOR/find'
  },
  checkInvitation: {
    method: 'get',
    url: '/partner/check-invitation',
    headers: {
      tokenInvite: ''
    }
  },
  confirmStatusMarkup: {
    method: 'put',
    url: '/partner/confirm-status-markup/ID'
  },
  rejectStatusMarkup: {
    method: 'put',
    url: '/partner/reject-status-markup/ID'
  },
  customerStatus: {
    method: 'get',
    url: '/partner/customer-status/ID'
  },
  archiveDocument: {
    method: 'delete',
    url: '/partner/document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: '/partner/document/restore'
  },
  archiveContact: {
    method: 'delete',
    url: '/partner/contact/archive'
  },
  restoreContact: {
    method: 'put',
    url: '/partner/contact/restore'
  },
  archiveInvoicingInformation: {
    method: 'delete',
    url: '/partner/invoicing-information/archive'
  },
  resendActivation: {
    method: 'post',
    url: '/partner/ID/resend-activation'
  },
  invites: {
    method: 'post',
    url: '/partner/invites'
  },
  businessOpportunity,
  commodity,
  bank,
  taskCompletionTime
}
